// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// Modules
import { AddButtonAutocompleteModule } from 'SearchApp/ts/features/add-button-autocomplete/add-button-autocomplete.module';
import { AutocompleteInPlaceModule } from 'SearchApp/ts/features/autocomplete-in-place/autocomplete-in-place.module';
import { ChartCorrelationSelectorModalModule } from './components/chart-correlation-selector-modal/chart-correlation-selector-modal.module';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { ColorPickerModule } from 'NewAngular/features/components/inputs/color-picker/color-picker.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { FundamentalChartModule } from 'ChartApp/ts/features/fundamental-chart/fundamental-chart.module';
import { DateRangeModule } from 'NewAngular/features/components/date-controls/date-range/date-range.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { MetricSelectorModalModule } from 'CalculationsApp/ts/features/metric-selector-modal/metric-selector-modal.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import { FullYearDateRangeModule } from 'NewAngular/features/components/date-controls/full-year-date-range/full-year-date-range.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { RadioButtonGroupModule } from 'NewAngular/features/components/inputs/radio-button-group/radio-button-group.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SimpleInputModule } from 'NewAngular/features/components/inputs/simple-input/simple-input.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { SkeletonLoadersListModule } from 'NewAngular/features/components/loaders/skeleton-loaders-list/skeleton-loaders.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
// This module exports the components that are used on all versions of the fund chart page:
// - The main fund chart page, which includes all features, the top nav bar, and side menu.
// - The fund chart creator page, which is used by partners like Seeking Alpha to create chart images for blog articles.
// - The fund chart editor page, which is a simplified version used only for editing interactive fund charts in the Chart Editor Modal.
export class FundChartPageSharedModule {
}
FundChartPageSharedModule.ɵfac = function FundChartPageSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartPageSharedModule)(); };
FundChartPageSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FundChartPageSharedModule });
FundChartPageSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AddButtonAutocompleteModule,
        AutocompleteInPlaceModule,
        ChartsSharedModule,
        ChartCorrelationSelectorModalModule,
        ColorPickerModule,
        CommonModule,
        ConfirmModalModule,
        DateRangeModule,
        DisabledModule,
        FeatureNeededModule,
        FormsModule,
        FullYearDateRangeModule,
        FundamentalChartModule,
        HelpModalModule,
        IconModule,
        LoadingSymbolModule,
        MetricSelectorModalModule,
        ModalBaseModule,
        RadioButtonGroupModule,
        SecurityListSelectorModalModule,
        SimpleDropdownModule,
        SimpleInputModule,
        SingleSelectDropdownModule,
        SkeletonLoadersListModule,
        TooltipModule] });
